import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import VehiclesList from "./VehiclesList";
import VehicleEdit from "./VehicleEdit";
import VehicleCreate from "./VehicleCreate";
import { Role } from "common/Constants";
import ProtectedRoute from "common/ProtectedRoute";

export const VehicleRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route path="/:id" element={<VehicleEdit />} />
      <Route path="/create" element={<VehicleCreate />} />
      <Route index element={ <ProtectedRoute roles={[Role.Admin, Role.VehicleAdmin]}><VehiclesList /></ProtectedRoute>} />
    </Routes>
  );
};
